export default {"src":"/_next/static/media/Check-Blue.6a58df14.svg","height":16,"width":16};